const fetchRemoteTrack = (src) =>
  fetch(src, { mode: 'cors' }).then((res) =>
    res.ok ? res.text() : Promise.reject(new Error(`FetchTextTrack error: ${res.statusText}`)),
  )

export default fetchRemoteTrack
